import { StackColumn, StackRow } from 'src/components';
import Image from 'src/components/Image';
import TextMaxLine from 'src/components/TextMaxLine';
import { MenuLink } from './link';
import { IconChevronRight } from 'src/libraries/icons';

//
//

const data = [
  {
    imageUrl:
      'https://res.cloudinary.com/carbonclick/image/upload/v1757405459/Merchant%20Portal/Article1-Hero_rhmf1e.png',
    title: 'From quiet action to confident storytelling',
    text: 'Learn how to talk about your climate action with confidence. This article shows why visibility matters, and gives simple steps for sharing your progress in a transparent, engaging way.',
    link: 'https://www.carbonclick.com/news-views/from-quiet-action-to-confident-sustainable-storytelling',
  },
  {
    imageUrl:
      'https://res.cloudinary.com/carbonclick/image/upload/v1757405459/Merchant%20Portal/Article2-Hero_orp3md.png',
    title: 'How to talk about climate action with confidence',
    text: 'Ever feel unsure about how to talk about your sustainability efforts? You’re not alone. Many businesses want to share what they’re doing for the planet - but words like carbon-neutral, net zero, or climate positive can feel overwhelming. Do you use them? Avoid them? And how do you make sure people understand what you really mean?',
    link: 'https://www.carbonclick.com/news-views/words-that-work-how-to-talk-about-climate-action-with-confidence',
  },
];

export const FeatureArticles = () => {
  return (
    <StackColumn gap={3}>
      {data?.map((item) => {
        return (
          <StackRow key={item?.title}>
            <Image sx={{ width: '160px !important', height: 110 }} src={item?.imageUrl} />

            <StackColumn flex={1}>
              <StackColumn gap={0.5}>
                <TextMaxLine line={1} variant="body2" sx={{ fontWeight: 'bold' }}>
                  {item?.title}
                </TextMaxLine>

                <TextMaxLine variant="body2">{item?.text}</TextMaxLine>
              </StackColumn>

              <MenuLink
                to={item?.link}
                title="Read more"
                target="_blank"
                endIcon={<IconChevronRight size={18} />}
                sx={{ fontWeight: 400 }}
              />
            </StackColumn>
          </StackRow>
        );
      })}

      <MenuLink
        to="https://www.carbonclick.com/news-views"
        target="_blank"
        title="View all articles"
        endIcon={<IconChevronRight size={18} />}
        sx={{ fontWeight: 400 }}
      />
    </StackColumn>
  );
};
